import { Component, OnInit, HostListener } from '@angular/core';
import { VrEventService } from 'src/app/services/vr-event.service';
import { VrEventTypeService } from 'src/app/services/vr-event-type.service';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { AuthorService } from 'src/app/services/author.service';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { IonDatetime } from '@ionic/angular';
import { SceneEvent } from 'src/app/models/vr-events/SceneEvent';

@Component({
  selector: 'app-scene-events-input',
  templateUrl: './scene-events-input.component.html',
  styleUrls: ['./scene-events-input.component.scss'],
})
export class SceneEventsInputComponent implements OnInit {

  public video: any;
  public authorVideoProgress: any;
  private videoCurrentTimeInterval = null;
  private isChangingVideoCurrentTime: boolean = false;
  public IonDateTimeHourValues: number[] = [0];
  public IonDateTimeMinuteValues: number[] = [0];

  constructor(public VrEventService: VrEventService,
    public VrEventTypeService: VrEventTypeService,
    public assetTypeService: AssetTypeService,
    public unfocusService: UnfocusElementService,
    public authorService: AuthorService
  ) { }

  ngOnInit() {
    this.initialiseVideo();
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e) {
    if (this.isChangingVideoCurrentTime) {
      this.setModalTransparency(1, e);
      this.isChangingVideoCurrentTime = false;
    }
  }

  initialiseVideo() {
    var videoSrcId = document.querySelector('a-videosphere').getAttribute('src');
    if (videoSrcId) {
      this.video = document.querySelector(videoSrcId);
    } else {
      var videoSphere = document.querySelector('a-videosphere');
      if (videoSphere && videoSphere.getAttribute('material')) {
        this.video = videoSphere.getAttribute('material').src;
      }
    }
    if (this.video) {
      this.authorVideoProgress = document.getElementById('video-progress');
      this.video.onloadedmetadata = () => {
        this.formatIonDateTimeMaxValues();
      };
    } else {
      setTimeout(() => { this.initialiseVideo() }, 1000);
    }
  }

  getVideoProgress(i) {
    return document.getElementById('video-progress-' + i);
  }

  getNumberOfEvents() {
    return this.VrEventService.getNumberOfEvents();
  }

  setVideoCurrentTime(event, i) {
    this.authorService.setVideoCurrentTime(event);
    this.VrEventService.scene.events[i].timeOfEvent = event.target.value;
    this.authorVideoProgress.setAttribute('value', event.target.value);
    // this.video.currentTime =  `${event.target.value.toFixed(1)}`;
  }

  initVideoCurrentTimeInterval(i, valueToApply: number) {
    this.videoCurrentTimeInterval = setInterval(() => {
      var videoProgress = this.getVideoProgress(i);
      var value: number = this.VrEventService.scene.events[i].timeOfEvent;
      var newValue = value + valueToApply;
      if (newValue <= this.video.duration && newValue > 0) {
        videoProgress.setAttribute('value', newValue.toString());
      }
    }, 10);
  }

  clearVideoCurrentTimeInterval() {
    if (this.videoCurrentTimeInterval) {
      window.clearInterval(this.videoCurrentTimeInterval);
      this.videoCurrentTimeInterval = null;
    }
  }

  setModalTransparency(opacity, event) {
    // document.getElementById('add-scene-events-modal').setAttribute('style', 'opacity: ' + opacity);

    var sceneSettingsModal = document.getElementById('scene-settings-modal');
    sceneSettingsModal.style.opacity = opacity;

    var sceneEventsModal = document.getElementById('add-scene-events-modal');
    sceneEventsModal.style.opacity = opacity;

    if (opacity == 1) {
      this.unfocusService.unfocus(event);
    }
  }

  formatIonDateTimeMaxValues() {
    var hours = Math.floor(this.video.duration / 60 / 60);
    var minutes = Math.floor(this.video.duration / 60);

    this.IonDateTimeHourValues = Array.from(Array(hours + 1).keys());
    this.IonDateTimeMinuteValues = Array.from(Array(minutes + 1).keys());
  }

  openVideoTimePicker(i: number, datePicker: IonDatetime) {
    var timeFormatted = this.authorService.formatCurrentTime(this.VrEventService.scene.events[i].timeOfEvent, this.video.duration);
    var hoursDuration = this.video.duration / 60 / 60;
    if (hoursDuration < 1) {
      timeFormatted = "00:" + timeFormatted;
    }
    document.getElementById('video-current-time-picker').setAttribute('index', (-1).toString());
    document.getElementById('video-current-time-picker').setAttribute('value', timeFormatted);
    document.getElementById('video-current-time-picker').setAttribute('index', i.toString());
    datePicker.open();
  }

  changeVideoProgressValue(event) {
    var index: number = +event.target.getAttribute('index');
    var formattedValue: string = event.detail.value;
    var time: number = 0;
    if (index == -1) {
      return;
    }
    if (formattedValue == this.authorService.formatCurrentTime(this.VrEventService.scene.events[index].timeOfEvent, this.video.duration)) {
      return;
    }
    time = this.getTimeFromFormat(formattedValue);
    if (time > this.video.duration) {
      time = this.video.duration;
    }
    this.VrEventService.scene.events[index].timeOfEvent = time;
  }

  getTimeFromFormat(formattedValue: string): number {
    var time: number = 0;
    var seconds: number = 0;
    var minutes: number = 0;
    var hours: number = 0;

    formattedValue = formattedValue.trim();
    seconds = +formattedValue.substring(6, 8);
    minutes = +formattedValue.substring(3, 5);
    hours = +formattedValue.substring(0, 2);

    minutes = minutes * 60;
    hours = hours * 60 * 60;
    time = hours + minutes + seconds;
    return time;
  }

  getActiveSceneEvents() {
    return this.VrEventService.getActiveSceneEvents();
  }

  getActiveAssetsInScene() {
    return this.VrEventService.getActiveAssetsInScene();
  }

  getEventTypes() {
    return this.VrEventTypeService.types;
  }

  getEventType(eventTypeId) {
    return this.VrEventTypeService.getType(eventTypeId);
  }

  isObjectEventType(eventTypeId: number) {
    return this.VrEventService.isObjectEventType(eventTypeId);
  }

  isMediaEventType(eventTypeId: number) {
    return this.VrEventService.isMediaEventType(eventTypeId);
  }

  isAssetVideoOrAudio(assetTypeId) {
    return this.VrEventService.isAssetVideoOrAudio(assetTypeId);
  }

  getAssetType(assetTypeId) {
    return this.assetTypeService.getType(assetTypeId);
  }

  selectNewAssetPosition(eventIndex) {
    // VrEventService.selectNewAssetPosition(assetInScene, eventIndex);
  }

  removeEvent(sceneEvent: SceneEvent) {
    this.VrEventService.removeEvent(sceneEvent, this.VrEventService.scene);
  }

  addEvent() {
    this.VrEventService.addEvent();
  }

  setSelected(sceneEvent) {
    if (this.VrEventService.scenes.length > 0) {
      if (sceneEvent.linkedContentId == -1) {
        this.setDefaultScene(sceneEvent);
      }
      else if (this.VrEventService.scenes.filter(x => x.sceneId == sceneEvent.linkedContentId && x.active).length == 0) {
        this.setDefaultScene(sceneEvent);
      }
    }
    return true;
  }

  setDefaultScene(sceneEvent) {
    var scenes = this.VrEventService.scenes.filter(x => x.active == true);
    if (scenes.length > 0) {
      sceneEvent.linkedContentId = scenes[0].sceneId;
    }
    else {
      sceneEvent.eventTypeId = 0;
    }
  }
}
